import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AMCompaniesContainer from 'src/components/accountManager/AMCompaniesContainer';
import NoAMCompaniesContainer from 'src/components/accountManager/NoAMCompaniesContainer';
import Container from 'src/components/shared/Container';
import { useRecommendationsContext } from 'src/context/RecommendationsProvider';
import { sendTrackingEvent } from 'src/utils/gtm';

const AMCompaniesPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const {
		filterApplied,
		isFilterLoading,
		companies,
		selfCompanies,
		activeCompanies,
		isLoadingCompanies,
		totalCompaniesCount,
		totalSelfCompaniesCount,
		totalActiveCompaniesCount,
	} = useRecommendationsContext();

	const hasCompanies = !!companies.length || isLoadingCompanies || filterApplied || isFilterLoading;

	const handleCreateCompany = () => {
		sendTrackingEvent({
			event: 'recr_dashboard_createacompany',
			eventLabel: location.pathname,
		});
		navigate('/create-company');
	};

	return (
		<>
			<Container>
				{hasCompanies ? (
					<>
						<AMCompaniesContainer
							selfCompanies={selfCompanies}
							totalSelfCompaniesCount={totalSelfCompaniesCount}
							activeCompanies={activeCompanies}
							isLoadingCompanies={isLoadingCompanies}
							totalCompaniesCount={totalCompaniesCount}
							totalActiveCompaniesCount={totalActiveCompaniesCount}
							allCompanies={companies ?? []}
							handleCreateCompany={handleCreateCompany}
							disableCreate={false}
						/>
					</>
				) : (
					<>
						<div className="h-[calc(100vh-70px)] sm:h-[calc(100vh-140px)] min-h-[350px] flex flex-col items-center justify-center">
							<NoAMCompaniesContainer onClick={handleCreateCompany} />
						</div>
					</>
				)}
			</Container>
		</>
	);
};

export default AMCompaniesPage;
